/**
 * SHA-256 atas byte berkas — memakai `crypto.subtle`, tanpa pustaka kripto tambahan.
 *
 * Nilai ini dikirim saat meminta upload target, lalu server mencocokkannya dengan objek yang
 * benar-benar mendarat di storage sebelum menandai berkas `active`. Karena itu ia HARUS dihitung
 * atas byte yang sama persis dengan yang di-`PUT` — bukan atas berkas sebelum kompresi, dan
 * bukan atas hasil pembacaan yang berbeda.
 *
 * Salah hitung di sini tidak muncul sebagai galat unggah; ia muncul jauh kemudian sebagai
 * finalisasi yang menolak bukti yang sebenarnya sudah terkirim — dan kurirnya sudah pulang.
 */

/** Heksadesimal huruf kecil, bentuk yang diharapkan `checksumSha256` di API-CONTRACT §4. */
export function toHex(buffer: ArrayBuffer): string {
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function sha256Hex(data: ArrayBuffer | Uint8Array): Promise<string> {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  // `slice()` menghasilkan ArrayBuffer yang dimiliki sendiri — menghindari kasus view yang
  // menunjuk sebagian buffer besar, yang akan menghasilkan hash atas byte yang salah.
  const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes.slice().buffer);
  return toHex(digest);
}

/**
 * Ukuran byte yang dilaporkan ke server.
 *
 * Dipisahkan sebagai fungsi supaya jelas bahwa ia diambil dari sumber yang SAMA dengan yang
 * di-hash — bukan dari properti `File.size` yang bisa merujuk berkas sebelum diproses.
 */
export function byteLength(data: ArrayBuffer | Uint8Array): number {
  return data instanceof Uint8Array ? data.byteLength : data.byteLength;
}
